export default __webpack_public_path__ + "static/media/bg_7.102ebc6c.png";